import { Spin } from 'platform-components';
import React from 'react';

import { AssignmentCollapsedStudents } from '../__collapsed/assignment__collapsed_students';

interface Props {
    teamId: number;
    selectedStudents: Array<number>;
    shouldShowStudentsLoader: boolean;
}

export const AssignmentStudentsPlaceholder = (props: Props) => {
    const { teamId, selectedStudents, shouldShowStudentsLoader } = props;

    if (shouldShowStudentsLoader) {
        return (
            <div className="assignment__loading-team">
                <Spin center />
            </div>
        );
    }

    if (selectedStudents.length === 0) {
        return null;
    }

    return <AssignmentCollapsedStudents teamId={teamId} />;
};
